// libs
import React from 'react';
import { FlatList } from 'react-native';

import platform from '@lyearn/core/utils/Platform';
import { useTranslation } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';
// components
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
// types
import { ScorecardQuestionType } from '@/types/schema';

import {
  bottomSheetContainer,
  bottomSheetRadius,
} from '../../../exercise/views/Details/components/ExerciseActivity/styles';
import { QuestionPreview } from '../Question';

interface ScorecardPreviewProps {
  title: string | undefined;
  questions: ScorecardQuestionType[] | null | undefined;
  onClose: () => void;
  skillName?: string;
  showBack: boolean;
}

const ScorecardPreview = (props: ScorecardPreviewProps) => {
  const { title, questions, onClose, skillName, showBack } = props;
  const totalQuestions = questions?.length || 0;
  const { t } = useTranslation();
  const isWeb = platform.OS === 'web';
  const description =
    (skillName ? `${skillName} • ` : '') +
    `${totalQuestions} ${t('Exercise:Question', {
      count: totalQuestions,
    })}`;

  if (!questions || questions.length === 0) return null;

  return (
    <Modal
      bottomSheetClasses={{
        paper: cn('bg-bg-primary overflow-hidden', bottomSheetRadius, {
          [bottomSheetContainer]: isWeb,
        }),
        containerClassName: '',
        handleClassName:
          'absolute top-8 w-44 h-4 rounded-full mb-8 bg-interactive-secondary-hover self-center',
        rootClassName: 'flex flex-col h-full drawer-root relative',
      }}
      bottomSheetContainerClassName={cn('native:mt-0', {
        [bottomSheetContainer]: isWeb,
      })}
      header={{
        title: title,
        description,
        onBack: showBack ? onClose : undefined,
      }}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      <Stack className="px-32 xs:px-20 xs:pt-28" direction="col">
        <FlatList
          data={questions}
          keyExtractor={(item) => item.id}
          renderItem={({ item }) => {
            return <QuestionPreview key={item.id} className="mb-28 xs:mb-32" question={item} />;
          }}
        />
      </Stack>
    </Modal>
  );
};

export default React.memo(ScorecardPreview);
